import {Component, Inject} from '@angular/core';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {ApiService} from "./api.service";
import {MatAnchor, MatButton, MatIconButton} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelpComponent} from "./help/help.component";

@Component({
  selector: 'anon-dialog',
  template: `
    <mat-dialog-content>
      <h2>Upozornění</h2>
      <p>Odstraněním dat dojde k anonymizaci Vašeho profilu.</p>
      <p>Po anonymizaci budete odhlášeni a už se do aplikace nebudete moci vrátit.</p>
      <p>Opravdu si přejete anonymizovat Váš účet?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="onNoClick()">Ne</button>
      <button mat-button [mat-dialog-close]="anonymizeConfirm()">Ano</button>
    </mat-dialog-actions>`,
  imports: [MatButton, MatDialogActions, MatDialogClose, MatDialogContent]
})
export class AnonDialog {
  onNoClick() {
    return false;
  }
  anonymizeConfirm() {
    return true;
  }
}
@Component({
  selector: 'token-dialog',
  template: `
    <mat-dialog-content>
      <h2>Job Token</h2>
      <code>{{data.token}}</code>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="true">Zavřít</button>
    </mat-dialog-actions>`,
  imports: [MatButton, MatDialogActions, MatDialogClose, MatDialogContent]
})
export class TokenDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {token: string}) {}
}

@Component({
    selector: 'app-root',
  imports: [
    RouterOutlet,
    MatIcon,
    MatToolbar,
    MatIconButton,
    MatAnchor,
    RouterLink,
    HelpComponent
  ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent {
  public wakeLock:any = null;

  constructor(public api: ApiService, private router: Router, private dialog: MatDialog, private snack: MatSnackBar) {
  }

  async stayAwake(){
    if ("wakeLock" in navigator) {
      try {
        this.wakeLock = await navigator.wakeLock.request("screen");
      }
      catch (e) {

      }
    }else{
      this.snack.open('Nepodařilo se zabránit spuštění vašeho spořiče obrazovky. Bohužel nejsme schopni diagnostikovat příčinu. Zkuste v nastavení telefonu zvýšit dobu, po kterou se obrazovka vypíná.', 'Zavřít', {duration: 5000});
    }
  }

  stopAwake(){
    this.wakeLock.release().then(() => {
      this.wakeLock = null;
    });
  }

  ngOnInit() {
    this.stayAwake();
  }

  ngOnDestroy() {
    this.stopAwake();
  }

  logout() {
    this.api.logout();
    this.router.navigate(['login']);
  }
  anonymize() {
    const ref = this.dialog.open(AnonDialog);
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.api.anonymizeRequest().then(() => {
          this.logout();
        });
      }
    });
  }

  async getToken() {
    const token = await this.api.getJobToken();
    console.log(token);
    this.dialog.open(TokenDialog, {data: {token: token}});
  }

}
